export default __webpack_public_path__ + "static/media/confrence.a6d3b495.svg";